<template>
	<div>
		<b-modal :ok-disabled="true" id="ImageModal" hide-footer hide-header centered cancel-disabled size="xl"
			body-class="p-0">
			<img @click="close()" style="width: 100%;height: auto;max-width: 100%;" :src="image"
				onerror="javascript:this.src='/assets/img/default/default-image.jpeg'" alt="">
		</b-modal>
	</div>
</template>

<script>


export default {
	name: 'ImageModal',
	data() {
		return {
			image: null
		}
	},
	created() {
		window.eventBus.$on('image.show', resp => {
			console.log('resp', resp)
			this.image = resp
			this.$bvModal.show('ImageModal')
		})
	},
	methods: {
		close() {
			this.$bvModal.hide('ImageModal')
		}
	}
}
</script> 
